/**
 * Florastory 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'

/**
 * Florastory 品牌主题配置
 */
export const theme = {
  // 首页背景图
  homeBg: '/images/florastory/home-bg.webp',
  // 标签模块背景图
  tagsBg: '/images/florastory/tag-background.webp',

  // 标签按钮选中状态 (使用品牌主色)
  tagActiveBg: '#00bc7e',
  tagActiveText: '#FFFFFF',

  // 标签按钮未选中状态
  tagInactiveBg: '#EAF8F0',
  tagInactiveText: '#00bc7e',

  // Tab 激活状态渐变底部装饰线
  tabActiveGradient: 'linear-gradient(270deg, #F6F7F9 0%, #00bc7e 95%)',
  // Tab 激活状态文字和下划线颜色
  tabActiveColor: '#00bc7e',
  // sticky-header 背景渐变
  stickyHeaderBg: 'linear-gradient(180deg, #DDF5E8 0%, #FFFFFF 100%)',
  // 顶部 Banner 撑满屏宽，无底部圆角
  topBannerRadius: '0',
  topBannerIndicatorActiveColor: '#00bc7e',
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
